import React from 'react';
import {Auth0User} from '../../../../Actions/Users/UsersDomain';
import {Button, Col, Form, Row} from 'antd';
import {DiazarFormInput} from '../../../../Components/Form/DiazarFormInput';

interface ViewProps {
    globalUser?: Auth0User,
    setIsLoaded: React.Dispatch<React.SetStateAction<boolean|undefined>>,
    updateHandler: (userToUpdate: Auth0User) => void;
}

export const EditeGlobalUser: React.FunctionComponent<ViewProps> = (props) => {
    const {globalUser, setIsLoaded, updateHandler} = props;

    const [givenName, setGivenName] = React.useState<string>('');
    const [isValidGivenName, setIsValidGivenName] = React.useState<boolean>(false);

    const [familyName, setFamilyName] = React.useState<string>('');
    const [isValidFamilyName, setIsValidFamilyName] = React.useState<boolean>(false);

    const [name, setName] = React.useState<string>('');
    const [isValidName, setIsValidName] = React.useState<boolean>(false);

    const [nikName, setNikName] = React.useState<string>('');
    const [isValidNikName, setIsValidNikName] = React.useState<boolean>(false);

    const isValidForm = React.useMemo( ()=>{
        const isValid = isValidGivenName && isValidFamilyName && isValidName && isValidNikName;
        if ( globalUser!== undefined && isValid ){
            return (
                givenName !== globalUser.given_name ||
                familyName !== globalUser.family_name ||
                name !== globalUser.name ||
                nikName !== globalUser.nickname
            );
        }

        return isValid;
    }, [familyName, givenName, globalUser, isValidFamilyName, isValidGivenName, isValidName, isValidNikName, name, nikName] );

    const cancelHandler = React.useCallback( ()=>{
        setIsLoaded(false);
    }, [setIsLoaded] );

    const saveUserHandler = React.useCallback( ()=>{
        if ( isValidForm && globalUser !== undefined){
            const userTooUpdate:Auth0User = {
                user_id: globalUser.user_id,
                given_name: givenName,
                family_name: familyName,
                name: name,
                nickname: nikName,
                email: globalUser.email,
                can_edite: false
            };

            updateHandler(userTooUpdate);
        }
    }, [familyName, givenName, globalUser, isValidForm, name, nikName, updateHandler] );

    if (globalUser === undefined) return null;

    return (
        <Form layout="horizontal" labelCol={{span: 8}} wrapperCol={{span: 16}}>
            <Row gutter={20}>
                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                    <DiazarFormInput id={'user-id'}
                                     label={'ID Único'}
                                     initialValue={globalUser.user_id}
                                     isReadOnly={true}
                                     isRequired={true}
                    />
                </Col>

                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                    <DiazarFormInput id={'user-mail'}
                                     label={'Correo Electrónico'}
                                     initialValue={globalUser.email}
                                     isReadOnly={true}
                                     isRequired={true}
                    />
                </Col>
            </Row>

            <Row gutter={20}>
                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                    <DiazarFormInput id={'user-given-name'}
                                     label={'Nombre(s)'}
                                     initialValue={globalUser.given_name}
                                     getState={(isValid, value) => {
                                         setIsValidGivenName(isValid);
                                         setGivenName(value);
                                     }}
                                     isRequired={true}
                    />
                </Col>

                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                    <DiazarFormInput id={'user-family-name'}
                                     label={'Apellido(s)'}
                                     initialValue={globalUser.family_name}
                                     getState={(isValid, value) => {
                                         setIsValidFamilyName(isValid);
                                         setFamilyName(value);
                                     }}
                                     isRequired={true}
                    />
                </Col>
            </Row>

            <Row gutter={20}>
                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                    <DiazarFormInput id={'user-given-name'}
                                     label={'Clave'}
                                     initialValue={globalUser.name}
                                     getState={(isValid, value) => {
                                         setIsValidName(isValid);
                                         setName(value);
                                     }}
                                     isRequired={true}
                    />
                </Col>

                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                    <DiazarFormInput id={'user-family-name'}
                                     label={'Apodo'}
                                     initialValue={globalUser.nickname}
                                     getState={(isValid, value) => {
                                         setIsValidNikName(isValid);
                                         setNikName(value);
                                     }}
                                     isRequired={true}
                    />
                </Col>
            </Row>

            <Row gutter={20} style={{marginTop: 10}}>
                <Col xs={{ span: 24, offset: 0 }}
                     sm={{ span: 12, offset: 0 }}
                     md={{ span: 8, offset: 8 }}
                     lg={{ span: 6, offset: 12 }}
                     xl={{ span: 4, offset: 16 }}
                     style={{marginTop: 10}}
                >
                    <Button type="primary"
                        onClick={cancelHandler}
                            block danger
                    >
                        Cancelar
                    </Button>
                </Col>
                <Col xs={{ span: 24 }}
                     sm={{ span: 12 }}
                     md={{ span: 8 }}
                     lg={{ span: 6 }}
                     xl={{ span: 4 }}
                     style={{marginTop: 10}}
                >
                    <Button type="primary"
                            disabled={!isValidForm}
                            onClick={saveUserHandler}
                            block
                    >
                        Enviar
                    </Button>
                </Col>
            </Row>
        </Form>
    );
};
